import { useRef } from 'react'
import React from 'react'
import AwsConfig from '../../Config/AwsConfig'
// import WikipediaCheckbox from './wikipediaCheckbox'

export default function DraganddropField(props) {
  // props for this file from parent
  const {
    englishField,
    display,
    senddata,
    displayte,
    sendname,
    sendnamete,
    personnames,
    sendsearchtrue,
    sendtruevalue,
    editmode,
    sendEditmode,
    editData,
    // handleActiveChange,
  } = props
  // refs for this file
  const dragItem = useRef()
  const dragOverItem = useRef()
  // function for editing names
  const edit = (_event, index) => {
    sendEditmode(false)
    sendtruevalue('crew', true)

    if (personnames.some(e => e.label === display[index]) === false) {
      sendsearchtrue(!true)

      const copyListItems = [...display]

      const value = copyListItems.splice(index, 1)
      const value1 = value

      sendname(value1[0].name_En)
      const copyListItemste = [...displayte]
      const valuete = copyListItemste.splice(index, 1)

      sendnamete(valuete)
      senddata(copyListItems, copyListItemste)
      // nameenglish(copyListItems)
      // nametelugu(copyListItemste)
    }
  }

  // function to store postion at the start of drag
  const dragStart = (e, position) => {
    dragItem.current = position
  }

  // function to store postion at the end of drag
  const dragEnter = (e, position) => {
    dragOverItem.current = position
  }

  // function to change positions in actal lists
  const drop = () => {
    const copyListItems = [...display]

    sendtruevalue('crew', true)
    const dragItemContent = copyListItems[dragItem.current]
    copyListItems.splice(dragItem.current, 1)
    copyListItems.splice(dragOverItem.current, 0, dragItemContent)
    // dragItem.current = null
    // dragOverItem.current = null

    const copyListItemste = [...displayte]
    const dragItemContentte = copyListItemste[dragItem.current]
    copyListItemste.splice(dragItem.current, 1)
    copyListItemste.splice(dragOverItem.current, 0, dragItemContentte)
    dragItem.current = null
    dragOverItem.current = null

    senddata(copyListItems, copyListItemste)
    // nameenglish(copyListItems)
    // nametelugu(copyListItemste)
  }

  // function to delete when x is clicked
  const Delete = (event, index) => {
    sendtruevalue('crew', true)
    const copyListItems = [...display]
    copyListItems.splice(index, 1)
    const copyListItemste = [...displayte]
    copyListItemste.splice(index, 1)
    senddata(copyListItems, copyListItemste)
    // nameenglish(copyListItems)
    // nametelugu(copyListItemste)
  }

  const compare = (a, b) => {
    const isSameUser = (a, b) => a.name_En === b.name_En

    // Get items that only occur in the left array,
    // using the compareFunction to determine equality.
    const onlyInLeft = (left, right, compareFunction) =>
      left.filter(
        leftValue =>
          !right.some(rightValue => compareFunction(leftValue, rightValue)),
      )

    const onlyInA = onlyInLeft(a, b, isSameUser)
    const onlyInB = onlyInLeft(b, a, isSameUser)

    const result = [...onlyInA, ...onlyInB]
    return result.length
  }

  const indication = props.modeUrl
    ? compare(editData[englishField], display) === 0 ||
      props.active[englishField] === 'TRUE'
      ? { borderColor: 'green' }
      : { borderColor: 'red' }
    : ''
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          border: '1px solid lightgray',
          ...indication,
        }}
        className='rounded'
      >
        {display &&
          display.map((item, index) => (
            <div
              onDragStart={e => dragStart(e, index)}
              onDragEnter={e => dragEnter(e, index)}
              onDragEnd={drop}
              key={index}
              draggable
              style={{ marginBottom: '10px' }} // Adjust margin bottom as needed
            >
              <div
                style={{
                  border: '1px solid black',
                  borderRadius: '1rem',
                  padding: '3px',
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={event => {
                    if (item.isAnonymous) {
                      if (editmode === true) {
                        edit(event, index)
                      }
                    }
                  }}
                >
                  <div
                    style={{ marginRight: '10px' }} // Adjust margin right as needed
                  >
                    {item.isAnonymous ? (
                      ''
                    ) : (
                      <img
                        style={{
                          width: '2rem',
                          height: '2rem',
                          borderRadius: '50%',
                        }} // Adjust width, height, and border radius as needed
                        src={AwsConfig.movieCdnUrl + item.posterURL}
                        // alt={item.name_En}
                      />
                    )}
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    {' '}
                    {/* Allow the text to take remaining space */}
                    <span style={{ fontSize: '16px' }}>
                      {item.name_En}
                    </span>{' '}
                    {/* Adjust font size and weight as needed */}
                  </div>
                  {item.isAnonymous ? (
                    <span
                      style={{
                        color: 'white',
                        backgroundColor: 'gray',
                        fontSize: '8px',
                        position: 'absolute',
                        top: '0px',
                        right: '35px',
                      }}
                    >
                      Anonymous
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                <button
                  type='button'
                  style={{
                    borderRadius: '50%',
                    padding: '5px 5px',
                    marginLeft: '10px',
                    height: '20px',
                    width: '20px',
                  }} // Adjust padding, margin left, and button size as needed
                  onClick={event => Delete(event, index)}
                >
                  <span style={{ position: 'relative', bottom: '10px', right: '1px' }}>
                    x
                  </span>
                </button>
              </div>
            </div>
          ))}
      </div>
    </>
  )
}
